// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2ziqS","approved":"Status_approved__16IRb","rejected":"Status_rejected__1vXsT","expired":"Status_expired__3MrVq","label":"Status_label__2uUca"};